import { Theme } from '@mui/material'
import { SxProps } from '@mui/system'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import { TomTable, useDefaultMRTOptions, useTomTable } from '@tom-ui/ui'
import { useTablePreferencesConfig } from '@tom-ui/utils'
import { MRT_Cell, MRT_Row, MRT_TableInstance } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { ReleaseDetailsViewStore } from '../../Stores/ReleaseDetailsViewStore'
import { useNonNumericReleaseDetailsColumns } from '../../tableConfigs/useNonNumericReleaseDetailsColumns'

interface Props {
  viewStore: ReleaseDetailsViewStore
  items: IOrderItem[]
  sx: SxProps<Theme>
  renderRowActions?: (props: {
    cell: MRT_Cell<IOrderItem>
    row: MRT_Row<IOrderItem>
    staticRowIndex?: number
    table: MRT_TableInstance<IOrderItem>
  }) => React.ReactNode
}

export const ReleaseDetailsTable = observer((props: Props) => {
  const { viewStore, items, sx, renderRowActions } = props

  const columns = useNonNumericReleaseDetailsColumns()

  const defaultOptions = useDefaultMRTOptions<IOrderItem>()

  const { savedPreferences, onPreferencesChange } = useTablePreferencesConfig(
    'planning/release-details',
  )

  const table = useTomTable(
    {
      enableSelectAll: false,
      enableRowSelection: false,
      enableExpanding: false,
      enableTopToolbar: false,
      columns,
      data: items,
      getRowId: row => row.id.toString(),
      muiTableContainerProps: { sx: { ...sx } },
      initialState: {
        ...defaultOptions.initialState,
        sorting: [
          {
            id: 'data.containerNumber',
            desc: true,
          },
        ],
        columnPinning: {
          left: ['mrt-row-actions', 'data.containerNumber'],
        },
      },
      renderRowActions,
    },
    undefined,
    undefined,
    { columns, savedPreferences, onPreferencesChange },
  )

  viewStore.setTableRef(table)

  return <TomTable table={table} />
})
